import './BrandArrow.css';

const ROTACIONES = {
  'up-left': 0,
  up: 45,
  'up-right': 90,
  right: 135,
  'down-right': 180,
  down: 225,
  'down-left': 270,
  left: 315,
};

/**
 * Flecha de la marca SC Group. Es siempre el mismo dibujo (el del hero);
 * lo único que cambia es hacia dónde apunta.
 */
export default function BrandArrow({
  direction = 'up-left',
  strokeWidth = 2.2,
  className = '',
  style,
  ...rest
}) {
  const rotacion = ROTACIONES[direction] ?? 0;

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={`brand-arrow ${className}`.trim()}
      style={{ '--brand-arrow-rotate': `${rotacion}deg`, ...style }}
      {...rest}
    >
      <line x1="17" y1="17" x2="7" y2="7" />
      <polyline points="7 17 7 7 17 7" />
    </svg>
  );
}
